module.exports = __webpack_public_path__ + "static/media/icon_openall_arrow_up.ae29da15.svg";